import { useEffect, useState, RefObject } from 'react';

interface TocItem {
  id: string;
  text: string;
  level: number;
}

const useGenerateToc = (
  markdownRef: RefObject<HTMLDivElement | null>,
  dependency: any
): TocItem[] => {
  const [tocItems, setTocItems] = useState<TocItem[]>([]);

  useEffect(() => {
    if (markdownRef.current) {
      const headings = Array.from(markdownRef.current.querySelectorAll('h3, h4'));
      const toc = headings.map((heading) => ({
        id: heading.textContent || '',
        text: heading.textContent || '',
        level: heading.tagName === 'H3' ? 3 : 4
      }));

      setTocItems(toc);
    }
  }, [dependency]);

  return tocItems;
};

export default useGenerateToc;
